import React from "react";
import { Container, Col, Row } from "reactstrap";

import Header from '../Component/Header';
import Footer from '../Component/Footer';
import TableSubscription from "../Component/TableSubscription";
import TableHosting from "../Component/TableHosting";

const Pricing = () => {
  return (
    <div id="investor" className="investor-container">
      <Header pricing={true} />

      <Container className="pricing-container">
        <p className="label">Our pricing is based on monthly subscription plus hosting consumption</p>

        <p className="text-header">1. Subscription</p>

        <div className="hosting-center">
        <TableSubscription />
        </div>

        <p className="text-header">2. Hosting</p>

        <div className="hosting-center">
        <TableHosting />
        </div>
        

      </Container>
      <Footer />
    </div>
  );
}

export default Pricing;